import Error404 from "../Components/Pages/Others/ErrorPage/Error404";

export const innerAuthRoutes = [
  // Authentication
  { path: `${process.env.PUBLIC_URL}/others/error_page_404`, element: <Error404 /> },
];
